import * as React from "react";
import { ArrowRight, CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const benefitsData = [{
  title: "Fractional CTO Leadership",
  description: "Navigate the complexities of health-tech with executive-level strategy tailored for rapid scaling, data security, and regulatory excellence.",
  points: ["Strategic Technology Roadmap", "Compliance Infrastructure", "Technical Debt Mitigation"]
}, {
  title: "Eir SaaS Decision Support",
  description: "Transform raw genetic data into actionable clinical insights with our proprietary platform designed specifically for precision providers.",
  points: ["Genomic Data Pipelines", "Provider-Centric UI/UX", "Seamless EHR Integration"]
}, {
  title: "Precision Lab Diagnostics",
  description: "Our in-house genetics laboratory provides the high-throughput biological foundation for data-driven healthcare solutions.",
  points: ["Rapid Sequencing Turnaround", "CAP/CLIA Accredited", "Custom Assay Development"]
}, {
  title: "Integrated Data Ecosystem",
  description: "Experience the force multiplier of having your tech strategy, software, and lab results managed under one unified vision.",
  points: ["Seamless Interoperability", "Centralized Bio-Data Hub", "Holistic Patient Insights"]
}];
export default function WhyNationalUpvc() {
  return <section data-section-id="221702" id="why-integrated-tech-matters" className="py-40 bg-background relative overflow-hidden text-foreground">
      {}
      <div className="absolute top-0 right-0 -translate-y-12 translate-x-1/3 w-[800px] h-[800px] bg-primary/10 rounded-full blur-3xl pointer-events-none" />

      <div className="container mx-auto px-6 md:px-12 max-w-7xl relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-start">
          
          {}
          <div className="lg:col-span-5 lg:sticky lg:top-32 flex flex-col gap-6">
            <div>
              <span className="text-sm font-bold tracking-widest text-primary uppercase font-default mb-2 block">
                The Eirion Advantage
              </span>
              <h2 className="text-4xl md:text-5xl font-default font-bold text-foreground leading-tight">
                The Synergy of Bio-Digital Intelligence.
              </h2>
            </div>
            
            <p className="text-muted-foreground text-lg font-sans leading-relaxed">
              Eirion Technology integrates strategic leadership, advanced software, and clinical diagnostics into a single, cohesive ecosystem. We don't just provide services; we build the infrastructure for the future of precision medicine.
            </p>

            <div className="pt-4">
              <Button asChild size="lg" className="rounded-md bg-primary text-primary-foreground hover:bg-primary/90">
                <Link to="#">
                  Discuss Your Project <ArrowRight className="ml-2 w-4 h-4" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-7 flex flex-col gap-8">
            {benefitsData.map((benefit, i) => <Card key={i} data-index={i} className="relative overflow-hidden border-border bg-card shadow-sm hover:shadow-lg transition-all duration-300 group">
                {}
                <div className="absolute -top-10 -right-6 text-[14rem] leading-none font-bold text-primary/10 select-none pointer-events-none font-default transition-transform duration-500 group-hover:scale-105 group-hover:text-primary/20">
                  {String(i + 1).padStart(2, '0')}
                </div>
                
                <CardHeader className="relative z-10 pb-4 pt-8 px-8">
                  <CardTitle className="text-2xl md:text-3xl font-default text-foreground">
                    {benefit.title}
                  </CardTitle>
                </CardHeader>
                
                <CardContent className="relative z-10 px-8 pb-8">
                  <p className="text-muted-foreground font-sans text-base md:text-lg leading-relaxed mb-6 max-w-[90%]">
                    {benefit.description}
                  </p>
                  
                  <ul className="flex flex-col gap-3">
                    {benefit.points.map((point, j) => <li key={j} data-index={j} className="flex items-center gap-3 text-sm font-medium text-foreground/80 font-sans">
                        <CircleCheck className="w-4 h-4 text-primary shrink-0" />
                        {point}
                      </li>)}
                  </ul>
                </CardContent>
              </Card>)}
          </div>

        </div>
      </div>
    </section>;
}